import React from 'react';
import { components } from 'react-select';
import './styles.scss';

export default props => (
    <components.DropdownIndicator {...props} className="dropdownIndicator">
        <span className="caret"></span>
    </components.DropdownIndicator>
);